import { useRouteMatch, Route, Switch } from 'react-router-dom'

import BranchBillPage from '@pages/Authorized/Branch/BillPage'
import PaymentPage from '@pages/Authorized/Branch/PaymentPage'
import ReceiptPage from '@pages/Authorized/Branch/ReceiptPage'

export default function BranchBillRouter(): JSX.Element {
  const { url } = useRouteMatch()

  return (
    <Switch>
      <Route path={`${url}/list`}>
        <BranchBillPage />
      </Route>
      <Route path={`${url}/receipt`}>
        <ReceiptPage />
      </Route>
      <Route path={`${url}/payment`}>
        <PaymentPage />
      </Route>
    </Switch>
  )
}
